export enum EAnimalTagDB {
  PNC_PET_FEE = 'PNC_PET_FEE',
  PNC_PET_RENT = 'PNC_PET_RENT',
  KNOWN = 'KNOWN',
  DISCOVERED = 'DISCOVERED',
  DISCOVERED_APP = 'DISCOVERED_APP',
  DISCOVERED_PAYING = 'DISCOVERED_PAYING',
}

export enum EAnimalTagUI {
  PNC_PET_FEE = 'PNC Pet Fee',
  PNC_PET_RENT = 'PNC Pet Rent',
  KNOWN = 'Known',
  DISCOVERED = 'Discovered',
  DISCOVERED_APP = 'Discovered (App)',
  DISCOVERED_PAYING = 'Discovered (Paying)',
}

export type TAnimalDiscoveredTagsDB =
  | EAnimalTagDB.DISCOVERED
  | EAnimalTagDB.DISCOVERED_APP
  | EAnimalTagDB.DISCOVERED_PAYING;
export type TAnimalDiscoveredTagsUI =
  | EAnimalTagUI.DISCOVERED
  | EAnimalTagUI.DISCOVERED_APP
  | EAnimalTagUI.DISCOVERED_PAYING;

export enum ETenantTagDB {
  KNOWN = 'KNOWN',
}

export enum ETenantTagUI {
  KNOWN = 'Known',
}
